type SectionProps = {
  children: React.ReactNode;
  className?: string;
  show?: boolean;
  onClick?: () => void;
};

const Section = ({
  children,
  className = "",
  show = true,
  onClick = () => {},
}: SectionProps) => {
  if (!show) return <></>;

  return (
    <div className={`max-w-sm m-auto ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

export default Section;
